import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const GolfLessons = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my golf lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps golf lessons businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for golf lessons businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most golf lessons businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my golf lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like golf lessons. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Golf Lessons - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Golf Lessons CRM", url: "/industries/golf-lessons" }
  ];

  const industryData = {
    name: 'Golf Instruction',
    title: 'Book More Lessons & Build Long-Term Coaching Relationships',
    subtitle: 'Automate lesson booking, track swing improvements, and convert trial lessons to packages',
    icon: '⛳',
    challenges: [
      'Trial lessons don\'t convert to packages',
      'Hard to schedule during peak times',
      'Students forget to book follow-ups',
      'Difficult to demonstrate progress',
      'Corporate group bookings are manual'
    ],
    solutions: [
      'Trial to package conversion automation',
      'Peak time scheduling optimization',
      'Automatic follow-up booking',
      'Video swing analysis tracking',
      'Corporate group coordination'
    ],
    features: [
      'Student CRM with handicap tracking',
      'Online lesson booking',
      'Video swing analysis',
      'Package management',
      'Progress documentation',
      'Corporate group booking',
      'Range and course access',
      'Review automation'
    ],
    results: [
      '80% trial conversion to packages',
      'Book 6+ weeks in advance',
      '5x corporate group revenue',
      '£6.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Golf Lessons UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for golf lessons businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for golf lessons UK, golf lessons business software, golf lessons customer management, golf lessons lead generation UK"
        url="/industries/golf-lessons"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default GolfLessons;